import type { SiteData } from './types';

// Este objeto contém os valores padrão para um novo site.
// Foi movido para um arquivo separado para evitar dependências circulares.
export const initialSiteData: Omit<SiteData, 'id' | 'createdAt' | 'updatedAt' | 'userId' | 'subscriptionId' | 'publishedAt' | 'aiCreditLastReset' | 'lastVisitedAt'> = {
  templateId: 'template1',
  siteName: '',
  subdomain: '',
  customDomain: '',
  faviconUrl: '',
  googleTagManagerId: '',
  googleAnalyticsId: '',
  googleAdsId: '',
  facebookPixelId: '',
  primaryColor: '#29ABE2',
  secondaryColor: '#00BCD4',
  accentColor: '#90EE90',
  isPublished: false,
  aiCredits: 20,
  viewCount: 0,
  suspendedReason: null,
  companyName: '',
  companyLogoUrl: 'https://placehold.co/150x60.png',
  companySummary: '',
  address: '',
  address_zipCode: '',
  address_street: '',
  address_number: '',
  address_complement: '',
  address_neighborhood: '',
  address_city: '',
  address_state: '',
  contactEmail: '',
  phoneDDI: '+55',
  phone: '',
  whatsappDDI: '+55',
  whatsapp: '',
  socialLinks: [],
  block_footer_logoUrl: 'https://placehold.co/150x60.png',
  block2_isActive: true,
  block2_order: 1,
  block2_backgroundImageUrl: 'https://placehold.co/1920x1080.png',
  block2_backgroundImage_ai_hint: 'modern business office',
  block2_overlayColor: 'rgba(0,0,0,0.5)',
  block2_title: 'Título Incrível para Seu Site',
  block2_subtitle: 'Um subtítulo cativante que descreve seu negócio.',
  block2_buttons: [
    { text: 'Nossos Serviços', link: '#servicos' },
    { text: 'Entre em Contato', link: '#contato' }
  ],
  block3_isActive: true,
  block3_order: 2,
  block3_title: 'Sobre Nossa Empresa',
  block3_text: '<p>Somos dedicados a fornecer o melhor serviço da indústria. Nossa paixão é ajudar você a ter sucesso.</p>',
  block3_photoUrl: 'https://placehold.co/800x600.png',
  block3_photo_ai_hint: 'team collaboration meeting',
  block3_actionButton: { text: 'Conheça Nossa História', link: '#sobre' },
  block4_isActive: true,
  block4_order: 3,
  block4_title: 'Nossos Serviços',
  block4_text: '<p>Descubra a gama de serviços que oferecemos para ajudar seu negócio a crescer e prosperar.</p>',
  block4_photoUrl: 'https://placehold.co/800x600.png',
  block4_photo_ai_hint: 'services',
  block4_actionButton: { text: 'Veja Todos os Serviços', link: '#servicos' },
  block_diff_isActive: true,
  block_diff_order: 4,
  block_diff_title: 'Nossos Diferenciais',
  block_diff_subtitle: 'Entenda por que somos a melhor escolha para você.',
  block_diff_items: [],
  block_diff_actionButton: { text: 'Por que Somos Diferentes?', link: '#diferenciais' },
  block5_isActive: true,
  block5_order: 5,
  block5_title: 'O Que Nossos Clientes Dizem',
  block5_subtitle: 'A satisfação de quem confia em nosso trabalho.',
  block5_testimonials: [],
  block5_actionButton: { text: 'Mais Depoimentos', link: '#depoimentos' },
  block6_isActive: true,
  block6_order: 6,
  block6_title: 'Clientes que Confiam em Nós',
  block6_clientLogos: [
    {id: 'logo-1', logoUrl: 'https://placehold.co/150x150.png', altText: 'Logo Cliente 1'},
    {id: 'logo-2', logoUrl: 'https://placehold.co/150x150.png', altText: 'Logo Cliente 2'},
    {id: 'logo-3', logoUrl: 'https://placehold.co/150x150.png', altText: 'Logo Cliente 3'},
    {id: 'logo-4', logoUrl: 'https://placehold.co/150x150.png', altText: 'Logo Cliente 4'},
    {id: 'logo-5', logoUrl: 'https://placehold.co/150x150.png', altText: 'Logo Cliente 5'},
    {id: 'logo-6', logoUrl: 'https://placehold.co/150x150.png', altText: 'Logo Cliente 6'},
  ],
  block7_isActive: true,
  block7_order: 7,
  block7_title: 'Nosso Portfólio',
  block7_subtitle: 'Veja alguns dos nossos projetos incríveis.',
  block7_galleryImages: [],
  block7_actionButton: { text: 'Ver Galeria Completa', link: '#galeria' },
  block8_isActive: true,
  block8_order: 8,
  block8_title: 'Perguntas Frequentes',
  block8_subtitle: 'Tire suas dúvidas mais comuns sobre nossos serviços.',
  block8_faqs: [],
  block10_isActive: true,
  block10_order: 9,
  block10_title: 'Visite-nos ou Entre em Contato',
  block10_column1_isActive: true,
  block10_column1_text: '<p><strong>Nosso Endereço:</strong><br/>Rua Exemplo, 123, Exemplo Bairro<br/>Cidade Exemplo - UF, 00000-000</p><p><strong>Horário de Funcionamento:</strong><br/>Segunda a Sexta: 09:00 - 18:00<br/>Sábado: 09:00 - 12:00<br/>Domingo: Fechado</p>',
  block10_column2_map_isActive: true,
  block10_column3_form_isActive: true,
  block10_column3_formTitle: 'Fale Conosco',
  block9_isActive: true,
  block9_order: 10,
  block9_backgroundImageUrl: 'https://placehold.co/1920x720.png',
  block9_backgroundImage_ai_hint: 'abstract background design',
  block9_overlayColor: 'rgba(0,0,0,0.5)',
  block9_impactPhrase: 'Vamos Construir Algo Incrível Juntos!',
  block9_actionButton: { text: 'Comece Agora', link: '#contato' },
  block_footer_isActive: true,
  block_footer_order: 11,
  block_footer_logoUrl: 'https://placehold.co/150x60.png',
  block_footer_additionalText: '<p>Sua Empresa Incrível Ltda.</p><p>CNPJ: 00.000.000/0000-00</p>',
  block_footer_showSitemap: true,
  block_footer_showAddress: true,
  block_footer_showPhone: true,
  block_footer_showWhatsapp: true,
  block_footer_showEmail: true,
  block_footer_showSocialLinks: true,
  block_footer_showContactForm: true,
  block_footer_showWhatsappButton: true,
  block11_privacyPolicyLink: '/politica-de-privacidade-generica',
  privacyPolicyContent: '<h1>Política de Privacidade</h1><p>Este é um modelo de política de privacidade. Por favor, edite este conteúdo para refletir as práticas de privacidade do seu site. Consulte um profissional jurídico se necessário.</p>',
};
